import API from '../api/api'

const GET_RESULTS_PENDING = 'GET_RESULTS_PENDING'
const GET_RESULTS_RESPONSE = 'GET_RESULTS_RESPONSE'
const GET_MORE_RESPONSE = 'GET_MORE_RESPONSE'

const initialState = {
  results: [],
  pending: false
}

// REDUCER
export default (state = initialState, action) => {
  switch(action.type) {
    case GET_RESULTS_PENDING: {
      return {
        ...state,
        pending: true
      }
    }
    case GET_RESULTS_RESPONSE: {
      if(action.response.success === true) {
        return  {
          ...state,
          results: action.response.results,
          pending: false
        }
      } else {
        return  {
          ...state,
          pending: false
        }
      }
    }
    // one case for every type: search_more/{type} returns the same envelope for all of them
    case GET_MORE_RESPONSE: {
      const type = action.resourceType;
      const section = action.response.success === true && action.response.results
        ? action.response.results[type]
        : null;

      if(!section) {
        return { ...state, pending: false }
      }

      const loaded = state.results[type] ? state.results[type].results : [];
      return {
        ...state,
        results: {
          ...state.results,
          [type]: {
            hasNextPage: section.hasNextPage,
            cursor: section.cursor,
            results: loaded.concat(section.results.map(result => ({
              id: result.id,
              gid: result.gid,
              title: result.title,
            }))),
          }
        },
        pending: false
      }
    }
    default:
      return state
  }
}

// ACTIONS
export const doSearch = (themeId, query) => { 
  return dispatch => {
    dispatch({
      type: GET_RESULTS_PENDING
    })

    API.search(
      themeId,
      query,
      response => {
        dispatch({
          type: GET_RESULTS_RESPONSE,
          response: response
        })
      }
    )
  }
}

export const searchMore = (type, query, cursor) => {
  return dispatch => {
    dispatch({
      type: GET_RESULTS_PENDING
    })

    API.searchMore(
      type,
      query,
      cursor,
      response => {
        dispatch({
          type: GET_MORE_RESPONSE,
          resourceType: type,
          response: response
        })
      }
    )
  }
}

export const searchMoreProducts = (query, cursor) => searchMore('products', query, cursor)

export const searchMoreCollections = (query, cursor) => searchMore('collections', query, cursor)

export const cancelSearch = (query) => { 
  return dispatch => {
    API.cancelSearch()
  }
}